import { render, staticRenderFns } from "./ReadMoreModal.vue?vue&type=template&id=d33ae90e&"
import script from "./ReadMoreModal.vue?vue&type=script&lang=js&"
export * from "./ReadMoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports